import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=63be186e&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63be186e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63be186e')) {
      api.createRecord('63be186e', component.options)
    } else {
      api.reload('63be186e', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=63be186e&scoped=true&", function () {
      api.rerender('63be186e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28mlcSIsPnIzh/JS/comp/Voucher-Unit.vue"
export default component.exports